import specFile from '@/data/rebilly-api.json';

export default {};
export const schema = {...specFile};
